<template>
  <div v-if="propValidationIsValid">
    <div class="d-flex justify-content-center flex-column flex-md-row justify-content-md-start align-items-md-center">
      <h4 class="mr-3 mb-1">
        {{graphTitle}}
      </h4>
    </div>
    <div class="graph__content mt-3">
      <base-graph
        :graphOptions="graph"
        :dataset="datasetOrdered"
        :datasetKey="graph.dataset_key"
        :pagination="pagination">
      </base-graph>
      <br>
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import BaseGraph from './BaseGraph'
import PropValidation from '@/mixins/PropValidationMixin'

export default {
  components: {
    BaseGraph,
    Multiselect
  },
  props: {
    /*
    {
      name: The title that should be displayed in the graph
      dataset_key: The key in the dataset that will draw under each element in the graph
      // Array of labels that are displayed at the end of the graph
      labels: [
        {
          color: The color of the given label,
          key: The key that is in the dataset that represents this label
          label: the text of the given label
        }
      ],
      // Array of criterias that will order the dataset.. its required at least one criteria
      criterias: [
        {
          name: The name of the given criteria,
          criteria: a function that will sort elements in the dataset
        }
      ]
    }
    */
    graph: {
      type: Object,
      required: true,
      validator: (graph) => {
        let requiredKeys = ['labels', 'dataset', 'dataset_key']

        let graphOptionsHasRequiredKeys = requiredKeys.every(key => {
          return graph.hasOwnProperty(key)
        })

        let everyDatasetItemContainsLabels = graph['dataset'].every(item => {
          return graph['labels'].every(element => {
            return item.hasOwnProperty(element.key) && item.hasOwnProperty(graph.dataset_key)
          })
        })

        return graphOptionsHasRequiredKeys && everyDatasetItemContainsLabels
      }
    },
    pagination: {
      type: Object,
      required: false,
      default: () => {
        return {
          show: true,
          perPage: 5
        }
      },
      validator: (options) => {
        return options.hasOwnProperty('show') && options.hasOwnProperty('perPage')
      }
    }
  },
  mixins: [PropValidation],
  data () {
    return {

    }
  },
  created: function () {

  },
  computed: {
    graphTitle: function () {
      return this.graph.name || this.$t('agenda.statistics.graphs.title')
    },
    activeSortMethod: function () {
      return this.selectedCriteria ? this.selectedCriteria.criteria : null
    },
    datasetOrdered: function () {
      if (this.activeSortMethod) {
        return this.graph.dataset.slice(0).sort(this.activeSortMethod)
      } else {
        return this.graph.dataset.slice(0).sort((a, b) => {
          return b.lq - a.lq
        })
      }
      // return null
    },
    graphTypes: function () {
      return {
        ...this.graph,
        dataset: this.datasetOrdered || []
      }
    },
  },
}
</script>

<style scoped lang="scss">
.statistics-multiselect{
  min-width: 400px;
  max-width: 40%;
}

@media only screen and (max-width: 768px) {
  .statistics-multiselect {
    min-width: 100%;
  }
}
</style>
